<script>
import moment from "moment";

// Custom Componetns
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Room Rate Plan Details Component

export default {
  page: {
    title: "Room Type",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Loader,
    // Switches,
  },
  data() {
    return {
      title: "Room Rate Plan",
      isLoading: true,
      ratePlan: [],
      roomTypes: [],
      dates: [],
      selectedRatePlanPrice: {
        id: null,
        room_price: null,
      },
    };
  },
  computed: {
    ...authComputed,
    currentProps() {
      return {
        isLoading: this.isLoading,
      };
    },
  },
  mounted() {
    this.getRatePlanDetails();
  },
  methods: {
    getRatePlanDetails() {
      UserService.getRatePlanDetails(this.$route.params.id)
        .then((ratePlan) => {
          this.isLoading = false;
          this.ratePlan = ratePlan;
          this.title += " - " + ratePlan.name;
          this.roomTypes = ratePlan.room_type;
          this.dates = [];
          this.roomTypes[0].date_wise_price.map((roomDate) => {
            this.dates.push({
              date: moment(roomDate.day_date),
              day: moment(roomDate.day_date).format("ddd"),
              class:
                moment(roomDate.day_date).format("dddd") == "Sunday"
                  ? "highlight"
                  : moment(roomDate.day_date).format("dddd") == "Saturday"
                  ? "highlight"
                  : "",
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    formatDate(date) {
      return moment(date).format("DD MMM");
    },
    selectRatePlanPrice(roomRate) {
      this.selectedRatePlanPrice.id = roomRate.id;
      this.selectedRatePlanPrice.room_price = roomRate.room_price;
    },
    deselectRatePlanPrice(
      roomRate,
      room_type_index,
      room_rate_plan_price_index
    ) {
      if (this.selectedRatePlanPrice.room_price != roomRate.price) {
        UserService.updateRatePlanPrice(
          {
            room_price: this.selectedRatePlanPrice.room_price,
          },
          this.selectedRatePlanPrice.id
        )
          .then((ratePlanPrice) => {
            this.roomTypes[room_type_index].date_wise_price[
              room_rate_plan_price_index
            ].room_price = ratePlanPrice.room_price;
            Middleware.notification("Successfully updated !!", "success");
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
      this.selectedRatePlanPrice.id = null;
      this.selectedRatePlanPrice.room_price = null;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <Loader :loading="currentProps">
              <div class="table-responsive">
                <table
                  class="table table-bordered table-hover border-primary mb-0"
                >
                  <thead>
                    <tr>
                      <th><span class="th-title">Types Of Room</span></th>
                      <th
                        v-for="(date, index) in dates"
                        :key="index"
                        class="text-center"
                        :class="date.class"
                      >
                        <span class="th-date"
                          >{{ date.day }} <br />{{
                            formatDate(date.date)
                          }}</span
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(roomType, roomRateIndex) in roomTypes"
                      :key="roomRateIndex"
                    >
                      <th>{{ roomType.name }}</th>

                      <td
                        v-for="(roomRate, key) in roomType.date_wise_price"
                        :key="key"
                        :class="dates[key].class"
                        class="text-center"
                      >
                        <b-form-input
                          v-if="selectedRatePlanPrice.id == roomRate.id"
                          id="name-input"
                          v-model="selectedRatePlanPrice.room_price"
                          type="number"
                          autocomplete="off"
                          @blur="
                            deselectRatePlanPrice(roomRate, roomRateIndex, key)
                          "
                        ></b-form-input>
                        <span v-else @click="selectRatePlanPrice(roomRate)">{{
                          roomRate.room_price
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.th-title {
  width: 170px;
  display: block;
}

.th-date {
  width: 100px;
  display: block;
}

.highlight {
  background-color: #e7f8ff;
}
</style>
